module.exports = __webpack_public_path__ + "static/p18-e7f8ddc9353e80962d7cce8050ceec98.jpg";